module.exports = __webpack_public_path__ + "static/18-609835ba7231e3859f81888f5170e79c.jpg";